import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './scene/brandSurfaces.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { applySceneToDocument } from './scene/scene';
import "katex/dist/katex.min.css";

applySceneToDocument();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
